import { useIsNewVehicle } from '~/context/vdp/VehicleContext';
import { usePriceDrop } from '~/hooks/vdp';
import useKBBPromo from '~/hooks/vdp/selectors/useKBBPromo';

export default function useBadges(): {
  showBadges: boolean;
  showGreatDealBadge: boolean;
  showNewBadge: boolean;
  showPriceDropBadge: boolean;
} {
  const showNewBadge = useIsNewVehicle();
  const { showKBBPromo: showGreatDealBadge } = useKBBPromo();
  const { showPriceDrop: showPriceDropBadge } = usePriceDrop();
  const showBadges = showGreatDealBadge || showNewBadge || showPriceDropBadge;

  return {
    showBadges,
    showGreatDealBadge,
    showNewBadge,
    showPriceDropBadge
  };
}
